// extracted by css-extract-rspack-plugin
export default {"single":"StatusBlock-module__single--evXGt","status-block":"StatusBlock-module__status-block--zvD1N","statusBlock":"StatusBlock-module__status-block--zvD1N"};